/**
 * MeetingActionItemService
 * Service for MeetingActionItem entity operations
 * Route: api/meetingactionitems
 * Controller: MeetingActionItemsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingActionItemService
 * Handles meeting action item CRUD operations and the promote-to-task action
 * Maps to /api/meetingactionitems endpoint
 */
export class MeetingActionItemService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingActionItemService.DEFAULT_SERVICE_PATH,
            basePath: MeetingActionItemService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all action items for a meeting
     * GET /api/meetingactionitems/meeting/{meetingId}
     * @param meetingId - Meeting ID
     * @returns Array of meeting action items
     */
    async getByMeeting(meetingId) {
        const response = await this.getByMeetingRaw(meetingId);
        return response.data ?? [];
    }
    getByMeetingRaw(meetingId) {
        const url = this.buildUrl('meeting/' + meetingId);
        return this.http.get(url);
    }
    /**
     * Promote an action item to a TaskManagement task. The created TaskID is stored back on the
     * action item. Returns the created TaskID.
     * POST /api/meetingactionitems/promote-to-task/{id}
     * @param id - Action item ID
     * @returns The created TaskID
     */
    async promoteToTask(id) {
        const response = await this.promoteToTaskRaw(id);
        return response.data ?? 0;
    }
    promoteToTaskRaw(id) {
        const url = this.buildUrl('promote-to-task/' + id);
        return this.http.post(url, {});
    }
}
MeetingActionItemService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingActionItemService.BASE_PATH = 'api/meetingactionitems';
//# sourceMappingURL=MeetingActionItemService.js.map